<template>
  <!-- Соцсеть канала: подпись с иконкой (Figma 41725:39501/39505/39513), у VK только иконка,
       или круглая иконка 24px без подписи (41715:39403/39405/39407) -->
  <span
    v-if="social"
    class="inline-flex shrink-0 items-center justify-center text-white"
    :class="
      compact
        ? 'size-6 rounded-full'
        : 'h-[22px] gap-1 rounded-[20px] px-1.5'
    "
    :style="{ background: BACKGROUNDS[social] }"
    :title="LABELS[social]"
  >
    <svg
      v-if="social === 'telegram'"
      viewBox="0 0 13.7918 11.7821"
      fill="none"
      :class="compact ? 'w-[13px]' : 'w-[14px]'"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.3632 0.0806049C12.5328 0.00923357 12.7184 -0.0153819 12.9007 0.00932021C13.0831 0.0340223 13.2554 0.107139 13.3999 0.221061C13.5444 0.334982 13.6556 0.485543 13.7222 0.657072C13.7887 0.828602 13.8081 1.01483 13.7782 1.19637L12.2219 10.6365C12.0709 11.5471 11.0718 12.0693 10.2367 11.6157C9.53815 11.2362 8.50061 10.6516 7.56737 10.0415C7.10075 9.73617 5.67139 8.75833 5.84706 8.06252C5.99802 7.46758 8.39974 5.23193 9.77214 3.90276C10.3108 3.38056 10.0652 3.07931 9.42904 3.55965C7.8494 4.75228 5.31319 6.56591 4.47465 7.07645C3.73493 7.5266 3.34928 7.60345 2.88815 7.5266C2.04687 7.38661 1.26665 7.16977 0.629858 6.90558C-0.230641 6.54876 -0.188783 5.36574 0.629171 5.02127L12.3632 0.0806049Z"
        fill="white"
      />
    </svg>
    <svg
      v-else-if="social === 'vk'"
      viewBox="0 0 15.2634 9.06762"
      fill="none"
      :class="compact ? 'w-[14px]' : 'w-[15px]'"
    >
      <path
        d="M14.65 9.06689H12.9788C12.3468 9.06689 12.1564 8.55497 11.0234 7.42129C10.0333 6.46703 9.61508 6.34839 9.36462 6.34839C9.01821 6.34839 8.92374 6.44359 8.92374 6.92035V8.42315C8.92374 8.8296 8.79192 9.06762 7.73 9.06762C6.69979 8.99841 5.70077 8.68544 4.81521 8.15449C3.92965 7.62353 3.1829 6.88979 2.63648 6.0137C1.33949 4.39859 0.436782 2.50341 0 0.478563C0 0.228098 0.0952061 0.00106798 0.572701 0.00106798H2.24247C2.67163 0.00106798 2.82616 0.192213 2.9946 0.633823C3.80531 3.01983 5.18873 5.09533 5.75045 5.09533C5.96576 5.09533 6.0595 5.00012 6.0595 4.46331V2.00552C5.98846 0.884288 5.39306 0.789814 5.39306 0.38409C5.40059 0.277049 5.44955 0.177162 5.52955 0.105643C5.60955 0.0341248 5.71427 -0.00338972 5.82149 0.00106798H8.44625C8.8051 0.00106798 8.92374 0.179762 8.92374 0.608922V3.92649C8.92374 4.28461 9.07754 4.40325 9.18592 4.40325C9.40124 4.40325 9.56675 4.28461 9.96149 3.8906C10.8073 2.85847 11.4985 1.70885 12.0135 0.477831C12.066 0.329869 12.1656 0.203192 12.2969 0.117211C12.4283 0.0312308 12.5842 -0.00931035 12.7408 0.00180028H14.4113C14.9122 0.00180028 15.0184 0.252266 14.9122 0.609655C14.3045 1.97059 13.5527 3.26251 12.6697 4.46331C12.4896 4.73794 12.4178 4.88075 12.6697 5.20298C12.8352 5.45345 13.4211 5.94266 13.8144 6.40771C14.3871 6.97894 14.8624 7.63953 15.222 8.36309C15.3655 8.82887 15.1268 9.06689 14.65 9.06689Z"
        fill="white"
      />
    </svg>
    <svg v-else viewBox="0 0 14 13.9999" fill="none" class="w-[14px]">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.22281 3.45456C5.39124 3.35814 3.96194 4.63394 3.64676 6.63078C3.38575 8.28441 3.84851 10.2994 4.24434 10.4008C4.41222 10.4438 4.81623 10.1336 5.11017 9.85536C5.16543 9.80305 5.24899 9.79425 5.3138 9.83402C5.772 10.1153 6.29077 10.3266 6.86269 10.3568C8.74302 10.4557 10.4093 8.97846 10.5078 7.09075C10.6063 5.20305 9.10314 3.55354 7.22281 3.45456ZM4.15571 13.0411C4.08479 12.9907 3.98709 13.0043 3.92765 13.068C3.13329 13.9185 1.10032 14.515 1.00719 13.3542C1.00719 12.4447 0.8037 11.6783 0.579648 10.8345C0.305242 9.80105 0 8.65145 0 6.98062C0 2.99636 3.2551 0 7.11456 0C10.974 0 14 3.14265 14 7.01932C14 10.896 10.8777 13.9612 7.15108 13.9612C5.82896 13.9612 5.18738 13.7743 4.15571 13.0411Z"
        fill="white"
      />
    </svg>
    <span v-if="!compact && social !== 'vk'" class="whitespace-nowrap text-xs font-semibold leading-4 text-white">{{ LABELS[social] }}</span>
  </span>
</template>

<script setup lang="ts">
  type Social = "telegram" | "vk" | "max";

  const props = defineProps<{
    place?: { social?: string | null; url?: string | null } | null;
    compact?: boolean;
  }>();

  const LABELS: Record<Social, string> = { telegram: "Telegram", vk: "VK", max: "MAX" };
  const BACKGROUNDS: Record<Social, string> = {
    telegram: "#28A7E8",
    vk: "#0077FF",
    max: "linear-gradient(90deg, #2273F9 0%, #3F4AE9 50%, #A54EDE 100%)",
  };

  // Соцсеть из поля social, иначе по ссылке — как в SEO-хелперах страницы канала
  const social = computed<Social | null>(() => {
    const s = String(props.place?.social || "").toLowerCase();
    if (s === "vk" || s === "vkontakte") return "vk";
    if (s === "max") return "max";
    if (s === "telegram") return "telegram";
    const url = String(props.place?.url || "").toLowerCase();
    if (url.includes("vk.com") || url.includes("vk.ru")) return "vk";
    if (url.includes("max.ru") || url.includes("my.mail.ru")) return "max";
    if (url.includes("t.me")) return "telegram";
    return null;
  });
</script>
